export const THEME_STORAGE_KEY = "darkMode";
export const DARK_THEME = "dark";
export const LIGHT_THEME = "light";

export function getPreferredTheme(storage = window.localStorage) {
  return storage?.getItem(THEME_STORAGE_KEY) === "false"
    ? LIGHT_THEME
    : DARK_THEME;
}

export function applyTheme(theme = getPreferredTheme()) {
  const resolvedTheme = theme === LIGHT_THEME ? LIGHT_THEME : DARK_THEME;

  document.documentElement.dataset.theme = resolvedTheme;
  document.documentElement.style.colorScheme = resolvedTheme;

  return resolvedTheme;
}

export function persistThemePreference(
  theme = DARK_THEME,
  storage = window.localStorage
) {
  const resolvedTheme = theme === LIGHT_THEME ? LIGHT_THEME : DARK_THEME;

  storage?.setItem(
    THEME_STORAGE_KEY,
    resolvedTheme === LIGHT_THEME ? "false" : "true"
  );

  return resolvedTheme;
}

export function setPreferredTheme(
  theme = DARK_THEME,
  storage = window.localStorage
) {
  const resolvedTheme = applyTheme(theme);
  persistThemePreference(resolvedTheme, storage);

  return resolvedTheme;
}
